import emitter from 'garden/src/js/utils/emitter'

export function showSpinner () {
  emitter.emit('overlay:show')
  emitter.emit('spinner:show')
}

export function hideSpinner () {
  emitter.emit('overlay:hide')
  emitter.emit('spinner:hide')
}
